import axios from 'axios';
import { isEmpty } from 'lodash';
import { getCookieValue } from 'util/Common';
import { API_URL } from 'util/config';
import {
  removeCookieValue, removeAllLocalStorage
} from './Common';
import { MessageStatusError, MessageStatusSuccess } from './MessageStatus';

const axiosClient = axios.create({
  headers: {
    'content-type': 'application/json'
  },
  baseURL: API_URL
});
// Add a response interceptor request
axiosClient.interceptors.request.use((config) => config);

// Add a response interceptor response
// Kiểm tra để chạy 401 1 lần duy nhất
let isExpried = true;
axiosClient.interceptors.response.use(async (response) => {
  const { status, config } = response;
  const { isShowMessage, apiType } = config;
  if (status === 401 && isExpried) {
    isExpried = false;
    // Hiển thị hết phiên làm việc
    MessageStatusError(status);
    await removeCookieValue('accessTokenBDT');
    await removeCookieValue('userId');
    await removeCookieValue('defaultUrl');
    await removeAllLocalStorage();
    setTimeout(() => {
      window.location.href = `${API_URL}/saml/logout?url=${window.location.protocol}//
              ${window.location.host}${window.location.hash}`;
    }, 1500);
  } else if (isShowMessage) {
    if (status === 200 || status === 201) {
      // Hiển thị thông báo thành công theo apiType với status === 200 || 201
      MessageStatusSuccess(apiType);
    } else {
      // Hiển thị thông báo lỗi theo status theo status >= 400 && status <= 500
      MessageStatusError(status);
    }
  }
  return response;
});

export const call = {};
export const apiCaller = (configAPI, getName) => {
  const accessToken = getCookieValue('accessTokenBDT');
  const {
    url, method, data, params, isShowMessage = true, apiType = ''
  } = configAPI;
  const options = {
    method,
    isShowMessage,
    apiType,
    url,
    validateStatus: () => true,
    data,
    headers: {
      'Content-Type': 'application/json;charset=utf-8',
      Authorization: accessToken ? 'Bearer '.concat(accessToken) : undefined
    },
    params
  };
  if (getName) {
    call[getName] = axios.CancelToken.source();
    return axiosClient({
      ...options,
      cancelToken: call[getName].token
    }).catch((err) => err.response);
  }
  return axiosClient({ ...options }).catch((err) => err.response);
};

export const cancelListToken = (listNameCancel = []) => {
  if (listNameCancel.length > 0) {
    listNameCancel.forEach((name) => {
      if (!isEmpty(call[name])) {
        call[name].cancel();
      }
    });
  }
};
